module.exports = __webpack_public_path__ + "img/layout-6.fd408894.jpg";